var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{class:_vm.pictureClass,attrs:{"src":_vm.picture
        ? ((!_vm.big ? _vm.picture.thumbnail_path : _vm.picture.public_path) + "?api_token=" + _vm.token)
        : ''},on:{"load":_vm.handleLoad}}),_c('h5',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }